import CompleteApiModel from '@widesk-ui/models/CompleteApiModel';
import WebsiteConnector from '@/models/WebsiteConnector';

const languageKeys = ['fr', 'en', 'jp'];
type ModelFile = { '@urn': Urn; url: string; };

const service = window.APP_CONFIG.services.find(service => service.id === 'website');

export const websiteConnector = new WebsiteConnector({
	baseURL: service?.configurations.api_endpoint,
});

export default class WebsiteServiceModel extends CompleteApiModel {
	public static get connector() {
		return websiteConnector;
	}

	public static serviceName = 'website';
	public static partitionName = 'jts';

	get languageKeys() {
		const objectLanguageKeys = Object.keys(this.get('translations') ?? {});
		return languageKeys.filter(key => objectLanguageKeys.includes(key));
	}

	getFiles(reference: Website_StonecodeFileTypeReference | Website_StonecodeFileTypeReference[]): ModelFile[] {
		const references = Array.isArray(reference) ? reference : [reference];
		const files = references.flatMap(ref => {
			const files = this.get<ModelFile[], ModelFile[]>(`@files.${ref}`, []);
			return Array.isArray(files) ? files : [files];
		});

		// On renvoi toujours les files du plus récent au plus ancien.
		return files.sort((a, b) => {
			const idA = parseInt(a['@urn'].split('stonecode_file_file:')[1] ?? '0');
			const idB = parseInt(b['@urn'].split('stonecode_file_file:')[1] ?? '0');
			return idB - idA;
		});
	}

	getFileUrls(reference: Website_StonecodeFileTypeReference) {
		const files = this.getFiles(reference);
		return files.map(f => f.url);
	}

	protected getTranslation<R, D>(key: string, startLang: string, defaultValue?: D): R | D {
		const keys = this.languageKeys;

		let startIndex = keys.indexOf(startLang);

		// Si la clé n'existe pas → on démarre à la fin
		if (startIndex === -1) {
			startIndex = keys.length - 1;
		}

		for (let i = startIndex; i >= 0; i--) {
			const result = this.get(`translations.${keys[i]}.${key}`) as any;
			if (result) return result;
		}

		return defaultValue!;
	}
}
